module.exports = __webpack_public_path__ + "media/stylesheets/images/media/advertising_kurashino_bg-238fbabac91f9c579cee50e36ffb9e21.png";